
  <form [formGroup]="sendForm" (ngSubmit)="onSubmit()"
        class="d-flex flex-column justify-content-center align-items-center w-100 p-4">
      <div >
        <h5>Wyślij zaproszenie</h5>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
      </div>
      <mat-dialog-content>
        <!-- <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-layout"> -->
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>Adres email</mat-label>
            <input matInput type="email" placeholder="email" required formControlName="email">
            @if (sendForm.hasError('email'))
            {
            <mat-error>Podany adres e-mail jest nieprawidłowy</mat-error>
            }
            <mat-error *ngIf="sendForm.get('email')?.hasError('usernameAlreadyExists')">
                Podany adres e-mail jest już <strong>używany</strong>
            </mat-error>
          </mat-form-field>
          <mat-radio-group formControlName="role">
            @for(role of roles; track role){
              <mat-radio-button [value] = "role.role_id">{{role.name}}</mat-radio-button>
            }
          </mat-radio-group>
        
      <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2" >
          <button mat-flat-button color="warn" class="btn btn-secondary" mat-dialog-close >Zamknij</button>
          <button mat-flat-button class="btn-with-icon s-button" color="accent" >Wyślij zaproszenie</button>
      </mat-dialog-actions>
    </mat-dialog-content>
    </form>